import { computed, makeObservable, observable } from "mobx";
import { ViewModelBase } from "@shoothill/core";
import { APIClient } from "Application";
import { StudentBehaviourModel } from "./StudentBehaviourModel";
import { StudentSessionBehaviourViewModel } from "../StudentSessionBehaviour/StudentSessionBehaviourViewModel";

export class StudentBehaviourViewModel extends ViewModelBase<StudentBehaviourModel> {
    public apiClient = new APIClient();

    public _studentSessionBehaviourViewModel: StudentSessionBehaviourViewModel;

    constructor(model: StudentBehaviourModel) {
        super(model);
        this._studentSessionBehaviourViewModel = new StudentSessionBehaviourViewModel(model.studentSessionBehaviour);
        makeObservable(this, {
            _studentSessionBehaviourViewModel: observable,
            studentSessionBehaviourViewModel: computed,
        });
    }

    public get studentSessionBehaviourViewModel(): StudentSessionBehaviourViewModel {
        return this._studentSessionBehaviourViewModel;
    }

    public validateSessionBehaviourModel = () => {
        this._studentSessionBehaviourViewModel.validateModel();
    };

    public isSessionBehaviourModelValid(): boolean {
        return this._studentSessionBehaviourViewModel.isModelValid();
    }
}
